import { mutatorAction } from 'satcheljs';
import { connectedAccountsStore } from '../../store/store';
export var updateBasicUseNewFolder = mutatorAction('updateBasicUseNewFolder', function (useNewFolder) {
    var store = connectedAccountsStore();
    store.connectBasicState.useNewFolder = useNewFolder;
});
//# sourceMappingURL=updateBasicUseNewFolder.js.map